jQuery(document).ready(function() {
    //change shipping value
  $('input[type=radio]').change(function() {
      if (this.value == 'standard') {
        var _data = $(this).data('price');
        $('.ship-price').text(_data);
        //$('.gst-price').text('0.00 HKD');
      }
      else if (this.value == 'express') {
        var _data = $(this).data('price');
        $('.ship-price').text(_data);
        //$('.gst-price').text('0.00 HKD');
      }
  });
  
  //disable click event
  jQuery('.reviews a').on('click', function(e){
  	e.preventDefault();
  });

  jQuery('.survey-slide').slick({
    infinite: false,
    speed: 500,
    swipe: false,
    //fade: false,
    //cssEase: 'linear',
    adaptiveHeight: true,
    arrows: false,
    accessibility: false,
    //vertical: true,
    //initialSlide: 7
  });
  
  //strip force reload iframe element
  function forceReflow (selector) {
    const [el] = document.querySelectorAll(selector)
    if (el) {
      el.style.display = 'none';
      el.offsetHeight;
      el.style.display = 'block';
    }
  }
  
  $('.survey-slide').on('afterChange', function(event, slick, currentSlide) {
    if(currentSlide == 0 || currentSlide > 8) {
      $('.backbutton').fadeOut('fast');
    }else {
      $('.backbutton').fadeIn('fast');
    }
    if(currentSlide == 9) {
      $('.survey-close').fadeIn('fast').addClass('exit');      
    }
    if(currentSlide == 6) {
      $('.backbutton').fadeOut('fast');
      startConfetti();
      setTimeout(function(){
        stopConfetti();
      },3000);
    } else {
     stopConfetti();
    }
    if(currentSlide < 7) {
      $('.progress-survey').addClass('active');
    } else {
      $('.progress-survey').removeClass('active');
    }
    if(currentSlide == 7) {
      $('.progress-prescription').addClass('active');
    } else {
      $('.progress-prescription').removeClass('active');
    }
    if(currentSlide == 8) {
      $('.progress-Checkout').addClass('active');
      forceReflow('.StripeElement');
    } else {
      $('.progress-Checkout').removeClass('active');
    }
  });

  $(document).on("click",".open-survey-popup", function(e) {
    $('body').addClass('open-popup');
  });
  $(document).on("click",".survey-close", function(e) {
    if($(this).hasClass('exit')) {      
      window.location.href = '/';
      return false;
    } else {
      location.reload();
    }
//     $('body').removeClass('open-popup');
//     $('.survey-slide').slick('slickGoTo', 0);
//     $("option:selected").prop("selected", false);
//     $('.right-power').text("");
//     $('.left-power').text("");
  });

  $(document).on("click",".show-more-field", function(e) {
    $('.hide-address').slideUp(100);
    var _this = $(this);
    setTimeout(function(){
      _this.parent().fadeOut('fast');
      $('.hide-more-field').fadeIn('fast');
      $('.form-hide').addClass('active');
      _this.parents('.slick-list').height("auto");
    },300);
  });
  $(document).on("click",".hide-more-field", function(e) {
    $(this).fadeOut('fast');
    $('.show-more-text').fadeIn('fast');
    $('.hide-address').fadeIn('fast');
    $('.form-hide').removeClass('active');
    $(this).parents('.slick-list').height("auto");
  });

  var addToCart = function(){
    var data = {};
    var left_variant_id = $('#left-lens').find(':selected').data('variant-id'),
    	right_variant_id = $('#right-lens').find(':selected').data('variant-id'),
    	selling_plan_id = $('#selling_plan').val();

    var properties = {
      variant_id: 'left:'+$('#left-lens').find(':selected').data('subs-variant-id')+'|right:'+$('#right-lens').find(':selected').data('subs-variant-id')
    };

    if($('#prescription').val() != ''){
      properties.Prescription = $('#prescription').val();
    }

    if (left_variant_id !== right_variant_id) {
      data = {
        items: [
          {
            quantity: 1,
            id: left_variant_id,
            properties: properties,
            selling_plan: selling_plan_id
          },
          {
            quantity: 1,
            id: right_variant_id,
            properties: properties,
            selling_plan: selling_plan_id
          }
        ],
      }
    } else {
      data = {
        items: [
          {
            quantity: 2,
            id: left_variant_id,
            properties: properties,
            selling_plan:selling_plan_id
          },
        ]
      };
    }

  	jQuery.ajax({
      type: "POST",
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function(response) {
            console.log("added to the cart");
            console.log(response);
            //unselect select
            //$("option:selected").prop("selected", false);

            // geting order date plus 30days added
            var date = new Date();
            date.setDate(date.getDate() + 30); // Set current date + 30 days as the new date
            const month = date.toLocaleString('default', { month: 'long' });
            const day = date.getDate();
            var newdate = month + ' ' + day;
            $('.date-text').text(newdate);

            //ajax cart item data
            $('.ajax-item').html('');
            var count_item = 0;
            $(response.items).each(function(){
              var _this = $(this);
              var qty = _this[0].quantity;
              var dimple_lens = $('.ajax-item').data('image');
              if ( qty == 2) {
                var _html = '<tr class="ajax-tr"><td><img src="'+ dimple_lens +'"></td><td><p>Left Eye (OS):</p></td><td><strong>'+ _this[0].variant_title +'</strong></td></tr><tr class="ajax-tr"><td><img src="'+ dimple_lens +'"></td><td><p>Right Eye (OD):</p></td><td><strong>'+ _this[0].variant_title +'</strong></td></tr>';
              } else if ( count_item == 0) {
                var lens_name = "Left Eye (OS):";
              } else {
                var lens_name = "Right Eye (OD):";
              }
              if ( qty != 2) {
                var _html = '<tr class="ajax-tr"><td><img src="'+ dimple_lens +'"></td><td><p>'+ lens_name +'</p></td><td><strong>'+ _this[0].variant_title +'</strong></td></tr>';
              }
              $('.ajax-item').append(_html);
              count_item++
            });

            $('.survey-slide').slick('slickNext');
            $(".popup-wrapper").animate({ scrollTop: 0 }, "fast");
            $('body').removeClass('open-modal');
          }
        });
      }
    });
  };

  $(document).on("click",".next-slide", async function(e) {
    if ($(this).hasClass('prescription-slide')) {
      e.preventDefault();
      var leftLensError = true;
      var rightLensError = true;
      var tnc = $('input[name="tnc"]');

      // validating product
      var leftLens = $('#left-lens');
      var rightLens = $('#right-lens');

      if (leftLens.find(':selected').data('variant-id') === '') {
        $('#left-lens-error').html('Please select a left lens');
        leftLensError = true;
      } else if (leftLens.find(':selected').data('variant-inventory') <= 0) {
        $('#left-lens-error').html('Sorry, the product is out of stock');
        leftLensError = true;
      } else {
        $('#left-lens-error').html('');
        leftLensError = false;
      }

      if (rightLens.find(':selected').data('variant-id') === '') {
        $('#right-lens-error').html('Please select a right lens');
        rightLensError = true;
      } else if (rightLens.find(':selected').data('variant-inventory') <= 0) {
        $('#right-lens-error').html('Sorry, the product is out of stock');
        rightLensError = true;
      } else {
        $('#right-lens-error').html('');
        rightLensError = false;
      }

      if (leftLensError || rightLensError) {
        console.log('error');
        return;
      } else {
        console.log('no error');
      }

      if (tnc.is(':checked') === false) {
        $('#tnc-error').text('Please confirm your prescription before proceeding ahead.');
        return false;
      } else {
        $('#tnc-error').text('');
      }

      addToCart();
      return false;

    } else {
      $('.next-slide, .goto-slide').removeClass('active');
      $(this).addClass('active');
      setTimeout(function(){
        $('.survey-slide').slick('slickNext');
        $(".popup-wrapper").animate({ scrollTop: 0 }, "fast");
      },400)

      return false;
    }
  });
  
  var leftImgHolder = $('#left-lens-img');
  var rightImgHolder = $('#right-lens-img');

  $('select#left-lens').on('change', function() {
    $('#prescription-next').addClass('btn--disable');
    $('input[name="tnc"]').attr('checked', false);
    var leftImg = $(this).find(':selected').data('img');
    var a = `<img src="${leftImg}" width="100">`;
    leftImgHolder.html(a);
    var leftLens = $(this);
    var power = leftLens.find(":selected").text();
    if(power == "-- Select --") {
      $('.left-power').text("");
    } else {
      $('.left-power').text(power);
    }
    if (leftLens.find(':selected').data('variant-id') === '') {
      $('#left-lens-img').removeClass("notempty");
      $('#left-lens-img').addClass("empty");
      $('#left-lens-error').html('Please select a left lens');
    } else if (leftLens.find(':selected').data('variant-inventory') <= 0) {
      $('#left-lens-img').removeClass("empty");
      $('#left-lens-img').addClass("notempty");
      $('#left-lens-error').html('Sorry, the product is out of stock');
      leftLensError = true;
    } else {
      $('#left-lens-img').removeClass("empty");
      $('#left-lens-img').addClass("notempty");
      $('#left-lens-error').html('');
      leftLensError = false;
    }
  });

  $('select#right-lens').on('change', function() {
    $('#prescription-next').addClass('btn--disable');
    $('input[name="tnc"]').attr('checked', false);
    var rightImg = $(this).find(':selected').data('img');
    var a = `<img src="${rightImg}" width="100">`;
    rightImgHolder.html(a);
    var rightLens = $(this);
    var power = rightLens.find(":selected").text();
    if(power == "-- Select --") {
      $('.right-power').text("");
    } else {
      $('.right-power').text(power);
    }
    if (rightLens.find(':selected').data('variant-id') === '') {
      $('#right-lens-img').removeClass("notempty");
      $('#right-lens-img').addClass("empty");
      $('#right-lens-error').html('Please select a right lens');
    } else if (rightLens.find(':selected').data('variant-inventory') <= 0) {
      $('#right-lens-img').removeClass("empty");
      $('#right-lens-img').addClass("notempty");
      $('#right-lens-error').html('Sorry, the product is out of stock');
      leftLensError = true;
    } else {
      $('#right-lens-img').removeClass("empty");
      $('#right-lens-img').addClass("notempty");
      $('#right-lens-error').html('');
      leftLensError = false;
    }
  });
   // tnc button
  $('input[name="tnc"]').on('change', function() {
    if ($(this).is(':checked') === false) {
      $('#prescription-next').addClass('btn--disable');
    } else {
      $('#tnc-error').text('');

       // validating product
      var leftLens = $('#left-lens');
      var rightLens = $('#right-lens');

      if (leftLens.find(':selected').data('variant-id') === '' || rightLens.find(':selected').data('variant-id') === '') {
        //$('#left-lens-error').html('Please select a left lens');
        //leftLensError = true;
        console.log("empty");
      } else if (leftLens.find(':selected').data('variant-inventory') <= 0 || rightLens.find(':selected').data('variant-inventory') <= 0) {
        //$('#left-lens-error').html('Sorry, the product is out of stock');
        //leftLensError = true;
        console.log("outofstock");
      } else {
        //$('#left-lens-error').html('');
        //leftLensError = false;
        console.log("ok");
        $('#prescription-next').removeClass('btn--disable');
      }
    }
  });

  $(document).on("click",".goto-slide",function() {
    if ( $(this).hasClass('no-prescription') ) {
       var slide_count = $('.survey-slide').slick('getSlick').slideCount - 2
    } else {
      var slide_count = $('.survey-slide').slick('getSlick').slideCount
    }
    $('.survey-slide').slick('slickGoTo', slide_count);
  });
  $(document).on("click",".slide-back",function() {
    $('.survey-slide').slick('slickPrev');
   // $('.left-power').text("");
    //$('.right-power').text("");
    $('#prescription-next').addClass('btn--disable');
    $('input[name="tnc"]').attr('checked', false);
  });

});



// New js
$(document).ready(function() {

  /**
   * Checkout Page
   */
  var stripe = Stripe('pk_test_51IIu2HI7rKoaZFt7oSeW05MZxxDBDfrlZJvzp9acQcYnFPkXPc1mpfXxXYAl0ZgLc5H6pHzI5xauCbWwJ5cEtJjt00MuXySfA3');
  var elements = stripe.elements();

  var style = {
    base: {
      color: '#0096ff',
      fontFamily: '"wigrum-light", "Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '13px',
      '::placeholder': {
        color: '#666'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  };
  
   var classes = {
    focus: 'is-focused',
    empty: 'is-empty'
  };


  // Create an instance of the card Element.
  var card = elements.create('card', {hidePostalCode: true, style: style, classes: classes});
  card.mount('#card-element');

  card.on('change', function(event) {
    var displayError = document.getElementById('card-errors');
    if (event.error) {
      displayError.textContent = event.error.message;
    } else {
      displayError.textContent = '';
    }
  });

  $(document).ready(function() {
    //all address field validation 
    jQuery.validator.addMethod("all_address", function(value, element) {
      var _val = $("#country").val() != "" && $("#province").val() != "" && $("#zip").val() != "" && $("#city").val() != "" && $("#address").val() != "";
      return _val; // this.optional(element) || /^http:\/\/mycorporatedomain.com/.test(value);

    }, "Please specify the correct domain for your documents");

    //lowercase validation
    $.validator.addMethod('lowercasesymbols', function(value) {
        return value.match(/^[^A-Z]+$/);
    }, 'Please enter a valid email address');

  	$('form[id="payment-form"]').validate({
      rules: {
        email: {
          required: true,
          email: true,
          lowercasesymbols: true,
          remote: {
            url: "https://app.dimplecontacts.com/middleware_hk/subscription/ajax/check_email",
            type: "post",
            data: {
              email: function() {
                return $( "#email" ).val();
              }
            }
          }
        },
        firstname: {
          required: true,
        },
        lastname: {
          required: true,
        },
        phone_number: {
          required: true,
          number: true,
          minlength: 9,
        },
        searchAddressList: {
          //required: true,
          all_address: true,
        },
        country: {
          required: true,
        },
        province: {
          required: true,
        },
        zip: {
          required: true,
        },
        city: {
          required: true,
        },
        address: {
          required: true,
        },
        cardname: {
          required: true,
        },
      },
      messages: {
        email:  {
          required: "Please enter a valid email address",
          remote: "It looks like you've already signed up for your free trial. To access your account, please log in <a href='/account/login'>here</a>"
        },
        //email: 'Please enter a valid email address',
        firstname: 'Please enter a firstname',
        lastname: 'Please enter a lastname',
        phone_number: 'Please enter a phone number',
        searchAddressList: {
          //required: "Please enter a delivery address",
          all_address: "Please enter a valid delivery address"
        },
        country: 'Please enter a country',
        province: 'Please enter a suburb or state',
        zip: 'Please enter a post code',
        city: 'Please enter a city',
        address: 'Please enter an address',
        cardname: 'Please enter your cardholder name',
      },

      submitHandler(form, event) {
        event.preventDefault();
        console.log('submit');
        $('#checkout-process').prop('disabled', true);
        stripe.createPaymentMethod({
          type: 'card',
          card: card,
          billing_details: {
            name: $('input[id="cardname"]').val(),
          },
        }).then(function(result) {
          if (result.error) {
            var errorElement = document.getElementById('card-errors');
            errorElement.textContent = result.error.message;
            console.log("error1");
            $('#checkout-process').prop('disabled', false);
          } else {
            processCheckoutPayment(result.paymentMethod.id)
            console.log("sucess");
            $('#checkout-process').addClass('btn--disable').prop('disabled', true);
            $('.loading').addClass('active');
            $('.backbutton, .survey-close').fadeOut('fast');
            $('.edit-prescription').fadeOut('fast');
          }
        });
      },
      invalidHandler: function(errors) {
        console.log(errors);
        console.log("error2");
        $('.slick-list').height("auto");
        $('#checkout-process').prop('disabled', false);
      }
    })
  })

  async function processCheckoutPayment(cardTokenId) {
  	var email = $('input[id="email"]').val();
    var firstname = $('input[id="firstname"]').val();
    var lastname = $('input[id="lastname"]').val();
    var phone_number = $('input[id="phone_number"]').val();
    var country = $('input[id="country"]').val();
    var province = $('#province option:selected').val();
    var zip = $('input[id="zip"]').val();
    var city = $('input[id="city"]').val();
    var address = $('input[id="address"]').val();
    var cardname = $('input[id="cardname"]').val();
    var shipping_type = $('input[name="shipping"]:checked').val();

    const cart = await getCartInfo();

    try {
      const res = await jQuery.ajax({
        type: "POST",
        url: 'https://app.dimplecontacts.com/middleware_hk/recharge/checkout',
        dataType: 'json',
        data: {
          email,
          firstname,
          lastname,
          phone_number,
          country,
          province,
          zip,
          city,
          address,
          cardname,
          shipping_type,
          cardTokenId,
          cart: JSON.stringify(cart),
        },
      });

      if (res.orderid && res.ordernumber && res.total_price) {
        console.log(res);
        // create cookie        
        //$('#recharge-checkout-id').html('#' + res.checkout_charge.charge_id);
        //$('#order-id').html('#' + res.checkout_charge.charge_id);
        //$('#order-user').html(firstname + ' ' + lastname);
        //$('.survey-slide').slick('slickNext');
        //$(".popup-wrapper").animate({ scrollTop: 0 }, "fast");
        // created cookie
        var cookie_value = firstname +' '+ lastname;
        var cookie_orderid = res.orderid;
        var cookie_ordernumber = '#DIM'+res.ordernumber;
        var cookie_price = res.total_price;
        document.cookie = "username="+cookie_value+"; path=/";
        document.cookie = "orderid="+cookie_orderid+"; path=/";
        document.cookie = "ordernumber="+cookie_ordernumber+"; path=/";
        document.cookie = "orderprice="+cookie_price+"; path=/";
        window.location.href = '/pages/thankyou';
        return false;
      } else {
        console.log("checkout error");
      }
    } catch(err) {
      console.log(err);
    }

//     $('.survey-slide').slick('slickNext');
//     $("html, body").animate({ scrollTop: 0 }, "fast");
  }

  function getCartInfo() {
    return jQuery.ajax({
      type: "POST",
      url: '/cart.js',
      dataType: 'json',
    });
  }

  // google map and address
  var autocomplete;
  const componentForm = {
    street_number: "short_name",
    route: "long_name",
    locality: "long_name",
    administrative_area_level_1: "short_name",
    country: "long_name",
    postal_code: "short_name",
  };

  function googleMapInit() {
    autocomplete = new google.maps.places.Autocomplete(
      document.getElementById("searchAddressList"),
      { types: ["address"],componentRestrictions: {country: 'hk'}}
    );

    autocomplete.setFields(["address_component"]);
    autocomplete.addListener("place_changed", fillInAddress);
  }

  google.maps.event.addDomListener(window, 'load', googleMapInit);

  function fillInAddress() {
    $('#country').val('');
    $('#zip').val('');
    $('#province').val('');
    $('#city').val('');
    $('#address').val('');

    const place = autocomplete.getPlace()
	var addresswithstreet = '';
    var street_number = '';
    var route = '';
    for (const component of place.address_components) {
      const addressType = component.types[0];
      if (componentForm[addressType]) {
        const val = component[componentForm[addressType]];
        console.log(addressType);
        console.log(val);
        if(addressType == 'street_number'){
        var street_number = val;
        }
        if(addressType == 'route'){
        var route = val;
        }
        switch(addressType) {
          case 'country':
            $('#country').val(val)
            break;
          case 'postal_code':
            $('#zip').val(val)
            break;
          case 'administrative_area_level_1':
            $("#province option").each(function(){
              if($(this).val()== val){ // EDITED THIS LINE
                  $(this).prop("selected", true);
              }
            });
            //$('#province').val(val)
            break;
          case 'locality':
            $('#city').val(val)
            break;
          case 'route':
            $('#address').val(val)
            break;
        }
        $("#searchAddressList-error").hide();
      }
    }
    addresswithstreet = street_number + ' ' + route;
    $('#address').val(addresswithstreet)
  }
  $("#searchAddressList").focus(function(){
    $(this).attr('autocomplete','current-searchAddressList');
  });
});




// Force the Element frame to paint once it is visible on the page

